import {
    Component,
    ojs,
    app,
    payload,
    state,
    State,
    v,
} from "modular-openscriptjs";
import { either, formatThousand, monetary } from "../../helpers";
import { dc, gc, uc } from "../../declarations";
import { dom } from "../../fotastart";

const h = app("h");
const broker = app("broker");
const $e = app("$e");

export default class CartProductView extends Component {
    updateItemTimeoutId = null;

    render(cartItemState, ...args) {
        let item =
            cartItemState instanceof State
                ? cartItemState.value
                : cartItemState;
        if (!item) return h.empty();

        let rowId =
            cartItemState.key ||
            `row-${item.id}-${item.cart_item_id || "default"}`;
        let product = item.options?.product || {};
        let user = product.owner;
        if (product.is_copied) user = product.copier;

        return h.div(
            {
                class: "card border-0 shadow-sm rounded-5 mb-3 bg-white overflow-hidden p-4",
                data_row_id: rowId,
            },
            // DIV 1: Image, Main Product Info (quantity), and Actions
            h.div(
                { class: "d-flex gap-3 align-items-center mb-2" },

                h.div(
                    { class: "flex-shrink-0" },
                    either(
                        item.thumbnail ||
                            (product.images && product.images.length > 0),
                        () =>
                            h.img({
                                src: item.thumbnail || product.images[0]?.path,
                                class: "rounded object-fit-cover",
                                style: "width: 70px; height: 70px;",
                                loading: "lazy",
                            }),
                        () =>
                            h.div(
                                {
                                    class: "bg-light rounded d-flex align-items-center justify-content-center text-secondary",
                                    style: "width: 70px; height: 70px;",
                                },
                                h.i({ class: "fas fa-box-open fs-4" }),
                            ),
                    ),
                ),

                h.div(
                    { class: "flex-grow-1 min-w-0" },

                    h.h6(
                        {
                            class: "fw-bold text-dark text-truncate mb-1 text-wrap",
                        },
                        item.name || product.name,
                    ),

                    h.div(
                        { class: "mb-1" },
                        either(
                            item.discounted_price &&
                                item.discounted_price < item.price,
                            () => [
                                h.span(
                                    { class: "text-primary fw-bold me-2" },
                                    monetary(
                                        item.discounted_price,
                                        dc.userCurrency,
                                    ),
                                ),
                                h.span(
                                    {
                                        class: "text-muted small text-decoration-line-through",
                                    },
                                    monetary(item.price, dc.userCurrency),
                                ),
                            ],
                            () =>
                                h.span(
                                    { class: "text-primary fw-bold" },
                                    monetary(item.price, dc.userCurrency),
                                ),
                        ),
                    ),

                    v(uc.cart, (cart) => {
                        let currentItem = cart.value[rowId] || item;
                        return h.div(
                            {
                                class: "d-flex gap-2 align-items-center bg-light rounded-pill p-1 d-inline-flex mb-1",
                            },
                            h.button(
                                {
                                    class: "btn btn-sm btn-outline-secondary border-0 rounded-circle p-0 d-flex align-items-center justify-content-center flex-shrink-0",
                                    style: "width: 24px; height: 24px;",
                                    onclick: this.method("decrementQuantity", [
                                        `cpv-pq-${rowId}`,
                                        rowId,
                                    ]),
                                },
                                h.i({ class: "fas fa-minus small" }),
                            ),
                            h.span(
                                {
                                    class: "fw-bold small text-center font-monospace px-2",
                                    id: `cpv-pq-${rowId}`,
                                    style: "min-width: 20px;",
                                },
                                currentItem.qty || "0",
                            ),
                            h.button(
                                {
                                    class: "btn btn-sm btn-white shadow-sm rounded-circle p-0 d-flex align-items-center justify-content-center flex-shrink-0 text-primary",
                                    style: "width: 24px; height: 24px;",
                                    onclick: this.method("incrementQuantity", [
                                        `cpv-pq-${rowId}`,
                                        rowId,
                                    ]),
                                },
                                h.i({ class: "fas fa-plus small" }),
                            ),
                        );
                    }),

                    either(user, () =>
                        h.div(
                            { class: "small text-secondary text-truncate" },
                            "Added By: ",
                            h.span({ class: "fw-bold" }, "@" + user?.username),
                        ),
                    ),
                ),

                // Actions
                h.div(
                    {
                        class: "d-flex align-items-center gap-2 align-self-start",
                    },
                    h.button(
                        {
                            class: "btn btn-light text-primary rounded-circle p-2 flex-shrink-0",
                            onclick: this.method("editItem", [product, item]),
                            title: "Edit Configuration",
                        },
                        h.i({ class: "fas fa-pen" }),
                    ),
                ),
            ),

            // DIV 2: Features
            h.call(() => {
                let selectedFeatures = item.options?.selectedFeatures || {};
                let elements = [];
                for (let featId in selectedFeatures) {
                    let values = selectedFeatures[featId] || [];
                    let optionTexts = [];
                    let featName = "";
                    values.forEach((vObj) => {
                        if (vObj && vObj.value) {
                            optionTexts.push(vObj.value);
                            if (vObj.feature_name) featName = vObj.feature_name;
                        }
                    });
                    if (optionTexts.length > 0) {
                        let mergedOptions = "";
                        if (optionTexts.length === 1) {
                            mergedOptions = optionTexts[0];
                        } else if (optionTexts.length === 2) {
                            mergedOptions = optionTexts.join(" & ");
                        } else {
                            let last = optionTexts.pop();
                            mergedOptions = optionTexts.join(", ") + " & " + last;
                        }
                        elements.push(
                            h.div(
                                {
                                    class: "badge bg-light text-dark border me-2 mb-2 p-2 rounded-3 text-wrap font-monospace text-start",
                                    style: "max-width: 100%;",
                                },
                                featName
                                    ? h.span(
                                          {
                                              class: "text-muted fw-bold text-uppercase small me-1",
                                              style: "font-size: 0.75rem;",
                                          },
                                          `${featName}:`,
                                      )
                                    : h.empty(),
                                h.span(
                                    {
                                        class: "fw-semibold text-primary text-wrap",
                                    },
                                    mergedOptions,
                                ),
                            ),
                        );
                    }
                }
                return elements.length > 0
                    ? h.div(
                          {
                              class: "mt-2 pt-2 d-flex flex-wrap align-items-center",
                          },
                          ...elements,
                      )
                    : h.empty();
            }),

            // DIV 3: Extras
            h.call(() => {
                let extraQuantities = item.options?.extraQuantities || {};
                let selExtraFeats = item.options?.selectedExtraFeatures || {};
                let productExtras = product.extras || [];
                let elements = [];

                for (let extraId in extraQuantities) {
                    let qty = parseInt(extraQuantities[extraId] || 0);
                    if (qty > 0) {
                        let extraProduct =
                            productExtras.find((x) => x.id == extraId) || {};
                        let extraName =
                            extraProduct.name ||
                            (item.options?.extras &&
                                item.options.extras[extraId]) ||
                            `Extra #${extraId}`;
                        let extraOptionsStr = "";

                        let extraFeats = selExtraFeats[extraId] || {};
                        let optList = [];
                        for (let fId in extraFeats) {
                            let vals = extraFeats[fId] || [];
                            let subTexts = [];
                            let fName = "";
                            vals.forEach((vObj) => {
                                if (vObj && vObj.value) {
                                    subTexts.push(vObj.value);
                                    if (vObj.feature_name)
                                        fName = vObj.feature_name;
                                }
                            });
                            if (subTexts.length > 0) {
                                let merged = subTexts.join(" & ");
                                let label = fName
                                    ? `${fName}: ${merged}`
                                    : merged;
                                optList.push(label);
                            }
                        }
                        if (optList.length > 0) {
                            extraOptionsStr = ` (${optList.join(", ")})`;
                        }

                        elements.push(
                            h.div(
                                {
                                    class: "text-muted small mb-1 lh-sm text-wrap",
                                },
                                h.i({
                                    class: "fas fa-plus-circle text-success me-1",
                                }),
                                `${qty}x ${extraName}${extraOptionsStr}`,
                            ),
                        );
                    }
                }
                return elements.length > 0
                    ? h.div({ class: "mt-2 pt-2" }, ...elements)
                    : h.empty();
            }),

            // DIV 4: Remove action link
            h.div(
                { class: "mt-2 pt-2 text-start" },
                h.a(
                    {
                        href: "#",
                        class: "text-danger small text-decoration-none fw-semibold",
                        onclick: this.method("removeItem", rowId),
                    },
                    "Remove From Cart",
                ),
            ),

            ...args,
        );
    }

    removeItem(rowId) {
        broker.send($e.cart.needs.itemRemoval, payload({ rowId }));
    }

    editItem(product, item) {
        broker.send(
            $e.product.needs.display,
            payload({
                product: product,
                cart_item: item,
            }),
        );
    }

    incrementQuantity(target, rowId) {
        this.changeValue("+", target, rowId);
    }

    decrementQuantity(target, rowId) {
        this.changeValue("-", target, rowId);
    }

    changeValue(type, target, rowId) {
        target = dom.id(target);
        if (!target) return;

        let current = Number(target.innerHTML);

        switch (type) {
            case "+": {
                target.innerHTML = Number(target.innerHTML) + 1;
                break;
            }
            case "-": {
                target.innerHTML = Math.max(Number(target.innerHTML) - 1, 1);
                break;
            }
        }

        let qty = Number(target.innerHTML);

        if (current != qty) {
            clearTimeout(this.updateItemTimeoutId);
            this.updateItemTimeoutId = setTimeout(() => {
                broker.send(
                    $e.cart.needs.itemUpdate,
                    payload({
                        rowId: rowId,
                        quantity: qty,
                    }),
                );
            }, 500);
        }
    }
}

ojs(CartProductView);
